import { css } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';

import { Image } from '@/libraries/design/components/image/src/image';

import paymentTeamAvatarUrl from '../assets/payment-team-grogu.svg';
import priyaHansraAvatarUrl from '../assets/priya-hansra.svg';
import rovoOpsMarkUrl from '../assets/rovo-ops.svg';
import zoomMarkUrl from '../assets/zoom.svg';

type MarkProps = {
	label: string;
	size?: number;
};

export const RovoOpsMark = ({ label, size = 16 }: MarkProps) => (
	<Image alt={label} css={markStyles} height={size} src={rovoOpsMarkUrl} width={size} />
);

export const SlackMark = ({ label, size = 16 }: MarkProps) => (
	<svg
		aria-label={label}
		css={markStyles}
		height={size}
		role="img"
		viewBox="23.53 23.8 33.35 33.35"
		width={size}
	>
		<path
			d="M30.5674 44.8842C30.5674 46.8232 29.0034 48.3881 27.0656 48.3881C25.1277 48.3881 23.5637 46.8179 23.5637 44.8842C23.5637 42.9505 25.1277 41.3804 27.0656 41.3804H30.5674V44.8842ZM32.3157 44.8842C32.3157 42.9452 33.8796 41.3804 35.8175 41.3804C37.7554 41.3804 39.3193 42.9452 39.3193 44.8842V53.6412C39.3193 55.5802 37.7554 57.145 35.8175 57.145C33.8796 57.145 32.3157 55.5802 32.3157 53.6412V44.8842Z"
			fill="#E01E5A"
			fillRule="evenodd"
		/>
		<path
			d="M35.8175 30.8153C33.8796 30.8153 32.3156 29.2504 32.3156 27.3115C32.3156 25.3725 33.8796 23.8076 35.8175 23.8076C37.7553 23.8076 39.3193 25.3725 39.3193 27.3115V30.8153H35.8175ZM35.8175 32.5909C37.7553 32.5909 39.3193 34.1558 39.3193 36.0948C39.3193 38.0338 37.7553 39.5986 35.8175 39.5986H27.0392C25.1013 39.5986 23.5374 38.0285 23.5374 36.0948C23.5374 34.1611 25.1013 32.5909 27.0392 32.5909H35.8175Z"
			fill="#36C5F0"
			fillRule="evenodd"
		/>
		<path
			d="M49.8472 36.0948C49.8472 34.1558 51.4111 32.5909 53.349 32.5909C55.2869 32.5909 56.8508 34.1558 56.8508 36.0948C56.8508 38.0338 55.2869 39.5986 53.349 39.5986H49.8472V36.0948ZM48.0989 36.0948C48.0989 38.0338 46.5349 39.5986 44.597 39.5986C42.6592 39.5986 41.0952 38.0338 41.0952 36.0948V27.3115C41.0952 25.3725 42.6592 23.8076 44.597 23.8076C46.5349 23.8076 48.0989 25.3725 48.0989 27.3115V36.0948Z"
			fill="#2EB67D"
			fillRule="evenodd"
		/>
		<path
			d="M44.597 50.1373C46.5349 50.1373 48.0989 51.7022 48.0989 53.6412C48.0989 55.5802 46.5349 57.145 44.597 57.145C42.6592 57.145 41.0952 55.5802 41.0952 53.6412V50.1373H44.597ZM44.597 48.3881C42.6592 48.3881 41.0952 46.8232 41.0952 44.8842C41.0952 42.9452 42.6592 41.3804 44.597 41.3804H53.3753C55.3132 41.3804 56.8772 42.9452 56.8772 44.8842C56.8772 46.8232 55.3132 48.3881 53.3753 48.3881H44.597Z"
			fill="#ECB22E"
			fillRule="evenodd"
		/>
	</svg>
);

export const ZoomMark = ({ label, size = 16 }: MarkProps) => (
	<Image alt={label} css={roundedMarkStyles} height={size} src={zoomMarkUrl} width={size} />
);

export const PriyaAvatar = ({ size = 24 }: { size?: 16 | 24 }) => (
	<Avatar name="Priya Hansra" size={size === 16 ? 'xsmall' : 'small'} src={priyaHansraAvatarUrl} />
);

export const PaymentTeamAvatar = () => (
	<Image alt="Payment Team" css={paymentTeamAvatarStyles} src={paymentTeamAvatarUrl} />
);

const markStyles = css({
	display: 'block',
	flexShrink: 0,
});

const roundedMarkStyles = css({
	display: 'block',
	flexShrink: 0,
	borderRadius: token('radius.small'),
});

const paymentTeamAvatarStyles = css({
	display: 'block',
	boxSizing: 'border-box',
	width: token('space.300'),
	height: token('space.300'),
	flexShrink: 0,
	borderRadius: token('radius.medium'),
});
